<style>
  svg > g[class*="raphael-group-"] > text{
    display: none !important;
  }

  #LoanPercentGraph span,
  #LoanPercentGraph svg{
    position: absolute !important;
    top: 5% !important;
    left: -30% !important;
    right: -23.5% !important;
    max-width: 600px;
    height: 90% !important;
    margin: auto !important;
    background: transparent !important;
  }

  #LoanPercentGraph span{
    background: transparent !important;
  }

  #LoanPercentGraph svg > g[class*="raphael-group-"] > text{
    display: none !important;
  }

  #LoanPercentGraph svg > g:first-of-type > g:first-child{
    opacity: 0;
  }
</style>

<template>
  <div id="LoanPercentGraph">
    <fusioncharts
      :type="type"
      :width="width"
      :height="height"
      :dataformat="dataFormat"
      :dataSource="dataSource"
    />

    <div class="position-absolute d-flex align-items-center justify-content-center" style="left: 1.5em; right: 1.5em; bottom: 3%; flex-wrap: wrap;">
      <div v-for="(label, index) in labels" :key="label.text" class="d-flex align-items-center mb-1"
        :class="{'mr-4': index < 2}">
        <div style="width: 12px; height: 12px; border-radius: 50%;margin-right: 0.5em"
          :style="{background: label.color}"></div>
          {{label.text}}
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import VueFusionChartsComponent from 'vue-fusioncharts/component';

  import FusionCharts from 'fusioncharts';
  import Charts from 'fusioncharts/fusioncharts.charts';
  import data from './data';

  const vueFusionCharts = VueFusionChartsComponent(FusionCharts, Charts);

  Vue.component('fusioncharts', vueFusionCharts);

  export default {
    name: 'usergraph',
    props: {
        caption: String,
        xAxisName: String,
        data: Array,
        timeFrame: String
    },
    created(){
      setTimeout(() => {
        const svg = this.$el.querySelector("svg");
        if(svg)
          svg.setAttribute("viewBox", `0 0 ${this.width} ${this.height}`);
      }, 200);
    },
    data() {
      return {
        type: "pie2d",
        width: "700",
        height: "383",
        dataFormat: "json",
        labels: [
          {
            text: "Approved",
            color: "#5d62b5"
          },
          {
            text: "Pending",
            color: "#29c3be"
          },
          {
            text: "Rejected",
            color: "#f2726f"
          }
        ]
      }
    },
    computed: {
      dataSource: function(){
        return {
          chart: {
            showlegend: 0,
            showpercentvalues: 1,
            showLabels: 0,
            showValues: 0,
            // usedataplotcolorforlabels: "0",
            legendItemFontBold: 0,
            legendItemFont: "Arial",
            legendItemFontSize: 18,
            legendBorderThickness: 0,
            legendShadow: 0,
            theme: "fusion",
            palettecolors: "5d62b5,29c3be,f2726f",
            usePlotGradientColor: "0"
          },
          data
        }
      }
    }
  }
</script>
